export const LIMIT_SHIFTS_ACCESS_BASED_ON_TIMELINESS_EXPERIMENT_TYPE =
  "LimitShiftsAccessBasedOnOrientationTimeliness";
